module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pl-dialog', {
    staticClass: "font-semibold text-gray-700 text-base",
    attrs: {
      "size": "lg",
      "title": 'Edit Genie Recap Summary',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('body', {
    staticClass: "mx-7 flex flex-col overflow-y-auto overflow-x-hidden h-full"
  }, [_c('div', {
    staticClass: "flex flex-col h-full my-5"
  }, [_c('div', {
    staticClass: "h-full rounded-md border border-solid border-gray-200"
  }, [(_vm.isRenderEditor) ? _c('Editor', {
    attrs: {
      "api-key": "no-api-key",
      "init": _vm.editorOptions
    },
    model: {
      value: (_vm.recap_summary),
      callback: function($$v) {
        _vm.recap_summary = $$v
      },
      expression: "recap_summary"
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('footer', {
    staticClass: "mx-7 mb-5"
  }, [_c('div', {
    staticClass: "flex justify-between w-full text-sm"
  }, [_c('button', {
    staticClass: "px-4 py-2 mr-2 bg-white border border-solid border-gray-200 hover:shadow-sm rounded cursor-pointer text-gray-600",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "sample px-5 py-2 bg-primary rounded cursor-pointer text-white font-medium disabled:opacity-50",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.saveGenieRecapSummary
    }
  }, [_vm._v("\n          Save Changes\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-9093c018!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/editGenieRecapModal.vue
// module id = 1102
// module chunks = 61